"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;

var _reactJss = require("react-jss");

var _fonts = require("../../styles/fonts");

var _variables = require("../../styles/variables");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// import {globalStyles} from "../../styles/global";
var useStyles = (0, _reactJss.createUseStyles)(_objectSpread(_objectSpread({}, _fonts.fontStyles), {}, {
  angle: function angle(props) {
    return {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transform: "rotate(".concat(props.flag ? "90deg" : "-90deg", ")"),
      transition: "0.3",
      cursor: "pointer"
    };
  },
  searchBox: {
    position: "relative"
  },
  searchBar: {
    width: "100%",
    fontFamily: "IranSansX",
    fontSize: "14px",
    height: "55px",
    color: _variables.colors.wolf,
    backgroundColor: _variables.colors.swan,
    borderRadius: "10px 10px 0 0",
    border: "none",
    direction: "rtl",
    textIndent: "15px"
  },
  list: {
    'border-radius': "8px",
    overflow: "hidden",
    direction: "rtl",
    maxHeight: "470px",
    minHeight: "200px",
    overflowY: "auto",
    overflowX: "hidden",
    position: "relative"
  },
  input: {
    position: "absolute",
    opacity: "0",
    zIndex: "-1",
    '&:checked + $tabLabel > $arrow': {
      transform: "rotate(90deg)"
    },
    '&:checked ~ $tabContent': {
      maxHeight: "100vh",
      padding: "10px 120px"
    }
  },
  itemHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    margin: "10px 20px 10px 20px",
    direction: "rtl"
  },
  listGroupBox: {
    borderRadius: "10px",
    border: "1px solid ".concat(_variables.colors.hare)
  },
  tab: {
    width: "100%",
    color: "white",
    overflow: "hidden"
  },
  tabLabel: {
    display: "flex",
    justifyContent: "space-between",
    padding: "10px 20px",
    fontWeight: "bold",
    cursor: "pointer",
    color: _variables.colors.wolf
  },
  tabContent: {
    maxHeight: "0",
    padding: "0 1em",
    color: "#2c3e50",
    background: "white",
    transition: "all .3s"
  },
  childrenItem: {
    marginBottom: "20px"
  },
  selectAll: {
    fontFamily: "IranSansX",
    position: "absolute",
    left: "15px",
    top: "30%",
    fontSize: "18px",
    cursor: "pointer"
  },
  arrow: {
    transform: "rotate(-90deg)",
    transition: "all .3s"
  },
  empty: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "200px",
    fontFamily: "IranSansX",
    userSelect: "none"
  },
  selected: function selected(props) {
    return {
      fontFamily: "IranSansX",
      position: "absolute",
      top: "35%",
      left: props.selectAll ? "70px" : "15px",
      direction: "rtl"
    };
  },
  option: {
    width: '280px'
  },
  space: {
    position: 'absolute',
    width: 'inherit'
  },
  optionMargin: {
    margin: "15px 0"
  }
}), {
  name: 'pds-list-group'
});
exports.useStyles = useStyles;